'use client';

import { useEffect, useState } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export default function MobileCtaBar() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const scrollable = document.body.scrollHeight - window.innerHeight;
      setVisible(scrollable > 0 && window.scrollY / scrollable > 0.25);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (dismissed) return null;

  return (
    <div
      className={`lg:hidden fixed bottom-0 inset-x-0 z-40 transition-transform duration-300 ${
        visible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      <div className="flex items-center gap-3 px-4 py-3 bg-surface/95 backdrop-blur-md border-t border-border shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-text-primary truncate">Check your own offer</p>
          <p className="text-xs text-text-secondary truncate">Free · about 60 seconds</p>
        </div>
        <Link
          href="/signup"
          className="flex-shrink-0 px-4 py-2.5 rounded-xl bg-primary text-primary-foreground text-sm font-semibold"
        >
          Analyze free
        </Link>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          aria-label="Dismiss"
          className="flex-shrink-0 p-1.5 text-text-secondary/70 hover:text-text-primary"
        >
          <Icon name="XMarkIcon" size={18} />
        </button>
      </div>
    </div>
  );
}
